<template>
  <div class="DarkWhite pa-4 ">
      <h2 class="subheading green--text">Signatories Utility</h2>
      <v-card class="mt-4">
      <PSUSignatoriesUtility/>
  </v-card>
  </div>
</template>

<script>
import PSUSignatoriesUtility from '../components/Utils/PSUSignatoriesUtility.vue'
  export default {
    components: {
      PSUSignatoriesUtility
    },
    data: () => ({
    }),
  }
</script>


<style scoped>
</style>